import React from 'react';

const QuestionSelectorComponent = (props) => {
  return (     
    props.questions && props.questions.options ? 
    <>
        <label className="quesHeading text-left page-title "> {props.questions.question ? props.questions.question : ''} </label>
        
        <ul className="list-group list-group-flush text-left" id="queryList">
          
       { props.questions.options.map((opt, index) =>
            
           <li key={index} className="list-group-item" data-optkey={opt.key}  onClick={props.nextQuestion.bind(this, opt)}>
            <span className="question">{opt.value}</span> <span className="pull-right">
              <img src="/images/icon_right_gray.png" className="icon_right_gray" alt="right arrow" />
            </span>
          </li>
        )}
         </ul>
      </>
   : ''  
  )
};

export default QuestionSelectorComponent;